var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-nav',{attrs:{"tabs":""}},[_c('b-nav-item',{attrs:{"disabled":""}},[_c('b',[_vm._v("Quiz App")])]),_c('b-nav-item',{attrs:{"disabled":""}},[_vm._v("Counter: "+_vm._s(_vm.numCorrect)+"/"+_vm._s(_vm.numTotal))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }